<template>
    <div class="c-twitter-feed">
        <!-- Dev Notes: Twitter handle to be editable as per requirements -->
        <a class="twitter-timeline" data-widget-id="265841979852718080" href="https://twitter.com/AHAScience">Tweets by @AHAScience</a>
    </div>
</template>

<!-- Dev Notes: This script is meant to be placed right after the above anchor element -->
<script>!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+"://platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","twitter-wjs");</script>



// WEBPACK FOOTER //
// demo/components/phd/twitter-feed.vue